export const pages = {
  AdminGeneric: {
    label: "Admin - Generic",
  },
  menu: {
    label: "Menu",
    timesheets: "timesheets",
    invoices: "invoices",
    dashboard: "dashboard",
    administration: "administration",
    scopes: "scopes",
    users: "users",
    permissions: "permissions",
    languages: "languages",
    logs: "logs",
    jobs_logs: "jobs_logs",
    sms_logs: "sms_logs",
    help_center: "help_center",
  },
  table: {
    label: "Tables",
    results: "results",
    items_per_page: "items_per_page",
    no_data_to_show: "no_data_to_show",
    test: "test",
  },
  form: {
    label: "Forms",
    select_option: "select_option",
    exist_field_error: "exist_field_error",
    notAssigned_language_error: "notAssigned_language_error",
    required_field_error: "required_field_error",
    upload_document_absence: "upload_document_absence",
    email_field_error: "email_field_error",
    email_field_error_unique: "email_field_error_unique",
    url_field_error: "url_field_error",
    alpha_field_error: "alpha_field_error",
    alphaNum_field_error: "alphaNum_field_error",
    numeric_field_error: "numeric_field_error",
    integer_field_error: "integer_field_error",
    decimal_field_error: "decimal_field_error",
    minLength_field_error: "minLength_field_error",
    maxLength_field_error: "maxLength_field_error",
    minValue_field_error: "minValue_field_error",
    maxValue_field_error: "maxValue_field_error",
    between_field_error: "between_field_error",
    sameAs_field_error: "sameAs_field_error",
    phone_field_error: "phone_field_error",
    nav_endpoint_field_error: "nav_endpoint_field_error",
    enter: "enter",
    choose_file: "choose_file",
    files_selected: "files_selected",
    password_field_error: "password_field_error"
  },
  button: {
    label: "Buttons",
    add: "add",
    next: "next",
    prev: "prev",
    remove: "remove",
    save: "save",
    submit: "submit",
    approver: "approver",
    rejecter: "rejecter",
    cancel_changes: "cancel_changes",
    cancel: "cancel",
    yes: "yes",
    no: "no",
    show_more: "show_more",
    not_now: "not_now",
    select_all: "select_all",
    deselect_all: "deselect_all",
    dropdown_select_label: "dropdown_select_label",
    dropdown_deselect_label: "dropdown_deselect_label",
    dropdown_selected_label: "dropdown_selected_label",
  },
  alerts: {
    label: "Alerts",
    success: "success",
    error: "error",
    success_operation: "success_operation",
    success_update: "success_update",
    unknown_error: "unknown_error",
    try_again_later: "try_again_later",
    redirecting_to_login_page: "redirecting_to_login_page",
    existing_email: "existing email",
    please_wait: "please_wait",
    dont_have_permission_msg: "dont_have_permission_msg",
    dont_have_nav_id: "dont_have_nav_id",
    too_large_file:"too_large_file",
    empty_file:"empty_file",
    file_not_supported: "file_not_supported",
    absence_not_remaining: "absence_not_remaining",
    not_allowed_to_access: "not_allowed_to_access",
    sms_delivery_error:"sms_delivery_error",
    max_total_size_exceeded:"max_total_size_exceeded",
    error_code: "error_code",
    url_not_found: "url_not_found",
    method_not_allowed: "method_not_allowed",
    unauthenticated: "unauthenticated",
    action_unauthorized: "action_unauthorized",
    no_results_found: "no_results_found",
    expired_token: "expired_token",
    invalid_token: "invalid_token",
    not_belong_to_scope: "not_belong_to_scope",
    language_not_changed_in_NAV: "language_not_changed_in_NAV",
    phone_not_changed_in_NAV: "phone_not_changed_in_NAV",
    sms_not_changed_in_NAV: "sms_not_changed_in_NAV",
    email_not_changed_in_NAV: "email_not_changed_in_NAV",
    invalid_NAV_credentials: "invalid_NAV_credentials",
    not_authorized_to_verify_phone: "not_authorized_to_verify_phone",
    invalid_input: "invalid_input",
    no_verification_code_for_this_phone: "no_verification_code_for_this_phone",
    sms_invalid_reciever: "sms_invalid_reciever",
    http_exception: "http_exception",
    sms_delivery_failed: "sms_delivery_failed",
    redirecting_to_other_scope: "redirecting_to_other_scope",
    internal_server_error: "internal_server_error",
    navision_no_response: "no_response"
  },
  AdminPage: {
    label: "Admin - Pages",
  },
  scope: {
    label: "Scopes",
    scopes: "scopes",
    list_of_scopes: "list_of_scopes",
    maintenance: "maintenance",
    live: "live",
    add_new_scope: "add_new_scope",
    update_new_scope: "update_new_scope",
    enter_name: "enter_name",
    name: "name",
    status: "status",
    default_language: "default_language",
    languages: "languages",
    scope_deleted: "scope_deleted",
    please_confirm: "please_confirm",
    please_wait: "please_wait",
    scope_added: "scope_added",
    scope_updated: "scope_updated",
    scope_nav_exist: "scope_nav_exist",
    scope_exist: "scope_exist",
    nav_endpoint: "nav_endpoint",
    nav_sharedKey: "nav_sharedKey",
    nav_scope_id: "nav_scope_id",
    enter_nav_scope_id: "enter_nav_scope_id",
    scope_logs: "scope_logs",
    jobs_logs: "jobs_logs",
    cci: "cci",
    portal_url: "portal_url",
    sms_logs: "sms_logs",
      enable_sms: "enable_sms",
      enable_email: "enable_email",
    properties_details: "Properties details for log",
    details: "Details for log",
    timezone: "Timezone",
    application_options: "application_options",
    is_timesheets_enabled: "is_timesheets_enabled",
    is_invoices_enabled: "is_invoices_enabled",
    application_options_error: 'At least one application option must be selected'

  },
  scopeSettingDashboard: {
    label: "Scopes settings",
    scope: "scope",
    scope_settings: "scope_settings",
    help_page: "help_page",
    maintenance_page: "maintenance_page",
    error_page: "error_page",
    email_template_page: "email_template_page",
    nav_credentials: "nav_credentials",
    mail_credentials: "mail_credentials",
    emails: "emails",
    connectivity_test: "connectivity_test",
    policies: "policies",
    sms_page: "sms_page",
    timesheet_config_page: "timesheet_config_page",
    config_cron_page: "config_cron_page",
    invoices: "invoices_page"
  },
  settings: {
    label: "Menu",
    profile: "profile",
    change_password: "change_password",
    edit_email: "edit_email",
    sign_in: "sign_in",
    sign_out: "sign_out",
    add_provider_title: "add_provider_title",
    add_provider_description: "add_provider_description"
  },
  pageUsers: {
    label: "Users",
    id: "id",
    users: "users",
    name: "name",
    email: "email",
    roles: "roles",
    created_at: "created at",
    updated_at: "updated at",
    action: "action",
    list_of_users: "list_of_users",
    affect_role_scopes: "affect_role_scopes",
    role: "role",
    scopes: "scopes",
    user_updated: "user_updated",
    user_added: "user_added",
    default_scope: "default_scope",
    invitation_sent: "invitation_sent",
    invitation_expired: "invitation_expired",
    signup_completed: "signup_completed",
    resending_invitation: "resending_invitation",
    last_actions: 'last_actions',
    notifications: 'notifications'
  },
  pageUserDetails: {
    label: "User details",
    title: "user_details",
    personal_details: "personal_details",
    first_name: "first_name",
    last_name: "last_name",
    email: "email",
    phone: "phone",
    receive_sms: "receive_sms",
    system_details: "system_details",
    sign_up: "sign_up",
    invitation_expired: "invitation_expired",
    in_progress: "in_progress",
    completed: "completed",
    last_login: "last_login",
    portal_id: "portal_id",
    role: "role",
    scope_and_nav_id: "scope_and_nav_id",
    scope_and_vendor_id: "scope_and_vendor_id",
    last_actions: "last_actions",
    last_notifications: "last_notifications",
    no_actions_found: "no_actions_found",
    no_notifications_found: "no_notifications_found",
    notification_data: "notification_data",
    show_data: "show_data",
    redirect_to_users_page: "redirect_to_users_page"
  },
  language: {
    label: "Languages",
    flags: "flags",
    flag: "language_flag",
    title: "language_title",
    french: "french",
    english: "english",
    spanish: "spanish",
    italian: "italian",
    german: "german",
    name: "name",
    code: "code",
    nav_language_id: "nav_language_id",
    list_of_language: "list_of_language",
    languages: "languages",
    language_deleted: "language_deleted",
    language_updated: "language_updated",
    language_added: "language_added",
    language_nav_exist: "language_nav_exist",
    add_new_language: "add_new_language",
    update_new_language: "update_new_language",
    enter_code: "enter_code",
    enter_name: "enter_name",
    enter_nav_language_id: "enter_nav_language_id",
    dictionary: "dictionary"
  },
  permission: {
    label: "Permissions",
    permissions: "permissions",
    roles: "roles",
    permissions_per_role: "permissions_per_role",
    find_permission: "find_permission"
  },
  maintenance: {
    label: "Maintenance page",
    maintenance: "maintenance",
    maintenance_page_title: "maintenance_page_title",
    maintenance_message_: "maintenance_message_"
  },
  error: {
    label: "Error page",
    error_page_title: "error_page_title",
    error_message_: "error_message_"
  },
  access_denied: {
    label: "Access denied page",
    access_denied_title: "access_denied_title",
    access_denied_description: "access_denied_description",
    available_scopes: "available_scopes"
  },
  help_center: {
    label: "Help page",
    popular_questions: "popular_questions",
  },
  help_configuration: {
    label: "Help configuration",
    help_configuration_language_label: "help_configuration_language_label",
    help_configuration_page_title: "help_configuration_page_title",
    help_configuration_overview: "help_configuration_overview"
  },
  policies: {
    label: "policies",
    policies_page_title: "policies_page_title",
    privacy_policy: "privacy_policy",
    terms_and_conditions:"terms_and_conditions",
  },
  terms_and_conditions: {
    label: "Terms And Conditions",
    terms_and_conditions_title: "terms_and_conditions_title",
    terms_and_conditions_overview: "terms_and_conditions_overview",
    find_our_terms: "find_our_terms"
  },
  privacy_policy: {
    label: "Privacy Policy",
    privacy_policy_title: "privacy_policy_title",
    privacy_policy_overview: "privacy_policy_overview",
    find_our_privacy_policy: "find_our_privacy_policy"
  },
  email_template_configuration: {
    label: "Email templates' settings",
    test_email_button: "test_email_button",
    email_template_page_title: "email_template_page_title",
    no_template_selected_message: "no_template_selected_message",
    template_language_label: "template_language_label",
    email_subject_label: "email_subject_label",
    email_subject_placeholder: "email_subject_placeholder",
    email_refer_label: "Ref",
    email_refer_placeholder: "email_refer_placeholder",
    email_title_label: "email_title_label",
    email_title_placeholder: "email_title_placeholder",
    email_subtitle_label: "email_subtitle_label",
    email_subtitle_placeholder: "email_subtitle_placeholder",
    email_introduction_label: "email_introduction_label",
    email_introduction_placeholder: "email_introduction_placeholder",
    toolbar_variables: "toolbar_variables",
    email_button_description_label: "email_button_description_label",
    email_button_description_placeholder: "email_button_description_placeholder",
    email_button_principal: "email_button_principal",
    email_button_principal_label_placeholder: "email_button_principal_label_placeholder",
    email_button_review: "email_button_review",
    email_button_review_label_placeholder: "email_button_review_label_placeholder",
    email_button_approve: "email_button_approve",
    email_button_approve_label_placeholder: "email_button_approve_label_placeholder",
    email_button_reject: "email_button_reject",
    email_button_reject_label_placeholder: "email_button_reject_label_placeholder",
    email_ending_label: "email_ending_label",
    email_ending_placeholder: "email_ending_placeholder",
    worker_first_name: "worker_first_name",
    worker_last_name: "worker_last_name",
    company: "company",
    job: "job",
    contract_start_date: "contract_start_date",
    contract_end_date: "contract_end_date",
    timesheet_start_date: "timesheet_start_date",
    timesheet_end_date: "timesheet_end_date",
    approver_name: "approver_name",
    firstName: "firstName",
    lastName: "lastName",
    login: "login",
    password: "password",
    scopeHelpdeskEmail: "scope_helpdesk_email",
    signInUrl: "signInUrl",
    confirmationUrl: "confirmationUrl",
    actualYear: "actualYear",
    general_email_templates: "general_email_templates",
    timesheets_email_templates: "timesheets_email_templates",
    invoices_email_templates: "invoices_email_templates",
    contact_first_name: "contact_first_name",
    contact_last_name: "contact_last_name",
    worker_full_name_n: "worker_full_name_n",
    date_of_issue_n: "date_of_issue_n",
    due_date_n: "due_date_n",
    total_hours_n: "total_hours_n",
    amount_due_n: "amount_due_n",
    currency_n: "currency_n",
  },
  general_email_templates_names: {
    label: "General email templates' titles",
    account_creation: "account_creation",
    email_confirmation: "email_confirmation"
  },
  timesheets_email_templates_names: {
    label: "Timesheets email templates' titles",
    timesheet_to_submit: "timesheet_to_submit",
    new_approval_permission_new_account: "new_approval_permission_new_account",
    new_contract_setup: "new_contract_setup",
    new_approval_permission: "new_approval_permission",
    pending_timesheet_reminder: "pending_timesheet_reminder",
    pending_timesheet: "pending_timesheet",
    timesheet_approved: "timesheet_approved",
    timesheet_rejected: "timesheet_rejected",
    timesheet_not_approved: "timesheet_not_approved",
  },
  invoices_email_templates_names: {
    label: "Invoices email templates' titles",
    invoices_creation: "invoices_creation",
    invoices_update: "invoices_update"
  },
  email_template: {
    label: "Email templates' fields",
    email_tempalte_to: "email_tempalte_to",
    email_tempalte_cci: "email_tempalte_cci",
    email_template_contractNumber: "email_template_contractNumber",
    email_template_contractStartDate: "email_template_contractStartDate",
    email_template_contractEndDate: "email_template_contractEndDate",
    email_template_timesheetStartDate: "email_template_timesheetStartDate",
    email_template_timesheetSubmission: "email_template_timesheetSubmission",
    email_template_approvers: "email_template_approvers",
    email_template_approvalFrequency: "email_template_approvalFrequency",
    email_template_worker: "email_template_worker",
    email_template_absence: "email_template_absence",
    email_template_overtime: "email_template_overtime",
    email_template_workerName: "email_template_workerName",
    email_footer: "email_footer",
    email_template_footer: "email_template_footer",
    email_templates_general_type: "email_templates_general_type",
    email_templates_timesheets_type: "email_templates_timesheets_type",
    email_templates_invoices_type: "email_templates_invoices_type",
  },
  nav_credentials: {
    label: "Navision credentials",
    nav_credentials_page_title: "nav_credentials_page_title",
    nav_end_point_label: "nav_end_point_label",
    nav_end_point_placeholder: "nav_end_point_placeholder",
    nav_shared_key_label: "nav_shared_key_label",
    nav_shared_key_placeholder: "nav_shared_key_placeholder",
    nav_username_label: "nav_username_label",
    nav_username_placeholder: "nav_username_placeholder",
    nav_password_label: "nav_password_label",
    nav_password_placeholder: "nav_password_placeholder",
  },
  mail_credentials: {
    label: "Mail credentials",
    mail_credentials_page_title: "mail_credentials_page_title",
    mail_credentials_oauth_title: "mail_credentials_oauth_title",
    mail_credentials_basic_auth_title: "mail_credentials_basic_auth_title",
    mail_credentials_oauth_description: "mail_credentials_oauth_description",
    mail_credentials_basic_auth_description: "mail_credentials_basic_auth_description",
    mail_host_label: "mail_host_label",
    mail_host_placeholder: "mail_host_placeholder",
    mail_port_label: "mail_port_label",
    mail_port_placeholder: "mail_port_placeholder",
    mail_username_label: "mail_username_label",
    mail_username_placeholder: "mail_username_placeholder",
    mail_password_label: "mail_password_label",
    mail_password_placeholder: "mail_password_placeholder",
    mail_test: "mail_test"
  },
  scope_emails: {
    label: "Scope emails",
    emails_page_title: "emails_page_title",
    it_helpdesk_label: "it_helpdesk_label",
    it_helpdesk_placeholder: "it_helpdesk_placeholder",
    admin_email_label: "admin_email_label",
    admin_email_placeholder: "admin_email_placeholder",
    cci_label: "cci_label",
    cci_placeholder: "cci_placeholder",
    test_email_label: "test_email_label",
    test_email_placeholder: "test_email_placeholder",
  },
  sms_configuration: {
    label: "sms notifications edit",
    sms_page_title: "sms_page_title",
    sms_template_page_title: "sms_template_page_title",
    sms_history_page_title: "sms_history_page_title",
    sms_allowed_countries_menu_title: "sms_allowed_countries_menu_title",
    sms_no_template_selected_message: "sms_no_template_selected_message",
    sms_template_language_label: "sms_template_language_label",
    sms_countries_label: "sms_countries_label",
    sms_allowed_countries_label: "sms_allowed_countries_label",
    sms_text_label: "sms_text_label",
    sms_text_placeholder: "sms_text_placeholder",
    sms_characters_number: "sms_characters_number",
    sms_number: "sms_number",
    sms_button_calculate: "sms_button_calculate",
    sms_test_button: "sms_test_button",
    sms_no_phone_error: "sms_no_phone_error",
    sms_credentials_page_title: "sms_credentials_page_title",
    sms_settings_page_title: "sms_settings_page_title"
  },
  sms_templates_names: {
    label: "sms notifications names",
    sms_pending_approval_reminder: "sms_pending_approval_reminder",
    sms_pending_submission_reminder: "sms_pending_submission_reminder",
    sms_rejected: "sms_rejected"
  },
  ovh_credentials: {
    label: "OVH credentials",
    ovh_credentials_page_title: "ovh_credentials_page_title",
    ovh_end_point_label: "ovh_end_point_label",
    ovh_end_point_placeholder: "ovh_end_point_placeholder",
    ovh_application_key_label: "ovh_application_key_label",
    ovh_application_key_placeholder: "ovh_application_key_placeholder",
    ovh_application_secret_label: "ovh_application_secret_label",
    ovh_application_secret_placeholder: "ovh_application_secret_placeholder",
    ovh_consumer_key_label: "ovh_consumer_key_label",
    ovh_consumer_key_placeholder: "ovh_consumer_key_placeholder",
    ovh_sender_label: "ovh_sender_label",
    ovh_sender_placeholder: "ovh_sender_placeholder",
    ovh_encoding_label: "ovh_encoding_label",
    ovh_encoding_placeholder: "ovh_encoding_placeholder",
    ovh_class_label: "ovh_class_label",
    ovh_class_placeholder: "ovh_class_placeholder",
    ovh_noStopClause_label: "ovh_noStopClause_label",
    ovh_noStopClause_placeholder: "ovh_noStopClause_placeholder",
  },
  connectivity_test: {
    label: "Test connectivity",
    connectivity_test_page_title: "connectivity_test_page_title",
    nav_request_sending: "nav_request_sending",
    nav_failure_message: "nav_failure_message",
    nav_success_message: "nav_success_message",
    smtp_request_sending: "smtp_request_sending",
    smtp_failure_message: "smtp_failure_message",
    smtp_success_message: "smtp_success_message",
    nav_test: "nav_test",
    test_nav_status: "test_nav_status",
    test_smtp_status: "test_smtp_status",
    monitoring_jobs: "monitoring_jobs",
    last_jobs: "Last jobs",
    pending_jobs: "Pending jobs",
    failed_jobs: "Failed jobs",
    payload_details: "Payload details for job",
    exception_details: "Exception details for job",
  },
  nav_status_history: {
    label: "Navision status history",
    nav_status_history_title: "nav_status_history_title",
    nav_status_test_date: "nav_status_test_date",
    nav_status_test_response_time: "nav_status_test_response_time",
    nav_status_test_result: "nav_status_test_result",
  },
    timesheet_config: {
        label: "Timesheet configuration",
        timesheet_config_page_title : "timesheet_config_page_title",
        timesheet_config_attachment: "timesheet_config_attachment",
        max_total_files_size_label: "max_total_files_size_label",
        max_total_files_size_label_placeholder: "max_total_files_size_label_placeholder",
        max_file_size_label: "max_file_size_label",
        max_file_size_label_placeholder: "max_file_size_label_placeholder",


    },
    cron_config: {
      label: "Cron configurations",
      cron_config_page_title: "cron_config_page_title",
      start_hour: "start_hour",
      end_hour: "end_hour",
      invalid_start_end_hour: "invalid_start_end_hour"
    },
  timesheet: {
    label: "Timesheet",
    timesheet_start_date: "timesheet_start_date",
    timesheet_contract_number: "timesheet_contract_number",
    timesheet_id_number: "timesheet_id_number",
    timesheet_organisation: "timesheet_organisation",
    timesheet_worker_name: "timesheet_worker_name",
    timesheet_approver_name: "timesheet_approver_name",
    timesheet_role: "timesheet_role",
    timesheet_status: "timesheet_status",
    timesheet_approved: "timesheet_approved",
    timesheet_accepted: "timesheet_accepted",
    timesheet_paid: "timesheet_paid",
    timesheet_rejected: "timesheet_rejected",
    timesheet_pending_approval: "timesheet_pending_approval",
    timesheet_pending_submission: "timesheet_pending_submission",
    to_submit:"to_submit",
    to_submit_description: "to_submit_description",
    to_approve:"to_approve",
    to_approve_description: "to_approve_description",
    submitted:"submitted",
    submitted_description: "submitted_description",
    approved_title: "approved_title",
    approved_description: "approved_description",
    no_timesheet_message: "no_timesheet_message",
    approve_all_timesheet: "approve_all_timesheet",
    rejection_reason: "rejection_reason",
    comment: "comment",
    total_time: "total_time",
    total_absences: "total_absences",
    overtime_comment_required: "overtime_comment_required",
    attachment_required: "attachment_required",
    rejection_reason_required: "rejection_reason_required",
    overtime_comment_too_long: "overtime_comment_too_long",
    timesheet_not_found: "timesheet_not_found"
  },
  invoice: {
    label: "Invoices list",
    invoices: "Invoices",
    list_of_invoices: "list_of_invoices",
    add_invoice: "add_invoice",
    edit_invoice: "edit_invoice",

    unique_id: "unique_id",
    vms_id: "vms_id",
    amount_supplier: "amount_supplier",
    amount_client: "amount_client",
    msp_fee: "msp_fee",
    vms_fee: "vms_fee",
    currency: "currency",
    worker_full_name: "worker_full_name",
    payment_status: "payment_status",
    issued_date: "issued_date",
    due_date: "due_date",
    vms_timesheet_id: "vms_timesheet_id",
    timesheet_hours: "timesheet_hours",
    timesheet_end_date: "timesheet_end_date",
    vms_assignment_id: "vms_assignment_id",
    assignment_bill_rate: "assignment_bill_rate",
    assignment_purchase_rate: "assignment_purchase_rate",
    vendor_gp_id: "vendor_gp_id",
    vendor_name: "vendor_name",

    enter_unique_id: "enter_unique_id",
    enter_vms_id: "enter_vms_id",
    enter_amount_supplier: "enter_amount_supplier",
    enter_amount_client: "enter_amount_client",
    enter_msp_fee: "enter_msp_fee",
    enter_vms_fee: "enter_vms_fee",
    enter_currency: "enter_currency",
    enter_worker_full_name: "enter_worker_full_name",
    enter_payment_status: "enter_payment_status",
    enter_issued_date: "enter_issued_date",
    enter_due_date: "enter_due_date",
    enter_vms_timesheet_id: "enter_vms_timesheet_id",
    enter_timesheet_hours: "enter_timesheet_hours",
    enter_timesheet_end_date: "enter_timesheet_end_date",
    enter_vms_assignment_id: "enter_vms_assignment_id",
    enter_assignment_bill_rate: "enter_assignment_bill_rate",
    enter_assignment_purchase_rate: "enter_assignment_purchase_rate",
    enter_vendor_gp_id: "enter_vendor_gp_id",
    enter_vendor_name: "enter_vendor_name",

    invoice_added: "invoice_added",
    invoice_updated: "invoice_updated",
    invoice_deleted: "invoice_deleted",

    redirect_to_invoices_page: "redirect_to_invoices_page",
    rapport_title: "rapport_title",
    rapport_total_invoices: "rapport_total_invoices",
    rapport_invoices_to_create: "rapport_invoices_to_create",
    rapport_invoices_to_update: "rapport_invoices_to_update",
    rapport_total_users: "rapport_total_users",
    rapport_users_to_create: "rapport_users_to_create",
    rapport_users_to_update: "rapport_users_to_update",
    rapport_import_invoices: "rapport_import_invoices",
    rapport_invalid_email_col: "rapport_invalid_email_col",
    rapport_invalid_date_col: "rapport_invalid_date_col",
    rapport_invalid_numeric_col: "rapport_invalid_numeric_col",
    rapport_invalid_string_col: "rapport_invalid_string_col",
    rapport_invalid_currency_col: "rapport_invalid_currency_col",
    rapport_required_col: "rapport_required_col",
  },
  invoice_details: {
    label: "Invoice details",

    page_title: "page_title",
    invoice_id: "invoice_id",
    invoice_created_date: "invoice_created_date",
    invoice_vendor_id: "invoice_vendor_id",
    invoice_vendor_name: "invoice_vendor_name",
    invoice_worker_name: "invoice_worker_name",
    invoice_payment_status: "invoice_payment_status",
    invoice_due_date: "invoice_due_date",
    invoice_timesheet_section_title: "invoice_timesheet_section_title",
    invoice_timesheet_id: "invoice_timesheet_id",
    invoice_timesheet_hours: "invoice_timesheet_hours",
    invoice_timesheet_end_date: "invoice_timesheet_end_date",
    invoice_assignment_section_title: "invoice_assignment_section_title",
    invoice_assignment_id: "invoice_assignment_id",
    invoice_assignment_bill_rate: "invoice_assignment_bill_rate",
    invoice_assignment_purchase_rate: "invoice_assignment_purchase_rate",
    invoice_payment_section_title: "invoice_payment_section_title",
    invoice_vendor_section_title: "invoice_vendor_section_title",
    invoice_payment_msp_fee: "invoice_payment_msp_fee",
    invoice_payment_vms_fee: "invoice_payment_vms_fee",
    invoice_payment_amount_supplier: "invoice_payment_amount_supplier",
    invoice_payment_amount_client: "invoice_payment_amount_client",
  },
  UserProfile: {
    label: "User - Profile",
  },
  profile: {
    label: "Change Email",
    title: "profile_page_title",
    email: "email",
    current_email: "current_email",
    new_email: "new_email",
    enter_email: "enter_email",
    remove_new_email_error: "remove_new_email_error",
    required_email_error: "required_email_error",
    valid_email_error: "valid_email_error",
    email_to_confirm: "email_to_confirm",
    resend_email: "resend_email",
    are_you_sure: "are_you_sure",
    confirm_change_email_message: "confirm_change_email_message",
    confirm_change_email_button: "confirm_change_email_button",
    failed_request: "failed_request",
    changed: "changed",
    success_change_email_message: "success_change_email_message",
    success: "success",
    confirm_remove_email_message: "confirm_remove_email_message",
    confirm_remove_email_button: "confirm_remove_email_button",
    removed: "removed",
    success_remove_email_message: "success_remove_email_message",
    success_resend_code_message: "success_resend_code_message",
  },
  personalDetails: {
    label: "Personal data",
    personalDetails: "personalDetails",
    preferredLanguage: "preferredLanguage",
    full_name: "full_name",
    first_name: "first_name",
    last_name: "last_name",
    password: "password",
    re_password: "re_password",
    phone_number: "phone_number",
    firstName_placeholder: "firstName_placeholder",
    lastName_placeholder: "lastName_placeholder",
    email_placeholder: "email_placeholder",
    notAssigned_scope_error: "notAssigned_scope_error",

    personal_contacts_title: "personal_contacts_title",
    have_verification_code: "have_verification_code",
    verify_your_phone: "verify_your_phone",
    verification_code_description: "verification_code_description",
    invalid_verification_code: "invalid_verification_code",
    enable_sms_description: "enable_sms_description",
    vendor_id: "vendor_id",
    nav_id: "nav_id",
    vendor_id_placeholder: "vendor_id_placeholder",
    nav_id_placeholder: "nav_id_placeholder",
  },

  sign_up: {
    label: "Sign up",
    expired_token_message: "expired_token_message",
    invalid_token_message: "invalid_token_message",
    used_token_message: "used_token_message",
    resend_link_button: "resend_link_button",
    new_link_sent_message: "new_link_sent_message",
    sign_up_completed_message: "sign_up_completed_message",
    terms_and_conditions_link_text: "terms_and_conditions_link_text",
    privacy_policy_link_text: "privacy_policy_link_text",
    accept_terms_and_privacy_text_before_links: "accept_terms_and_privacy_text_before_links",
    accept_sms_text: "accept_sms_text",
    phone_verified: "phone_verified",
    sign_up_details: "sign_up_details",
    sign_up_contact: "sign_up_contact",
    sign_up_security: "sign_up_security",
  },
  allowed: {
    label: "Not allowed page",
    not_allowed: "not_allowed",
    not_allowed_access: "not_allowed_access",
  },
  common:{
    attachments:"attachments"
  },
  excel:{
    excel:"excel",
    import:"import",
    export:"export"
  }
}

